import {
    BackButton,
    Container,
    convertFromBoolean,
    convertToBoolean,
    Divider,
    Form,
    FormDate,
    FormDropDown,
    FormInput,
    FormRadio,
    getFormattedDate,
    Header,
    NameForm,
    PersonForm,
    SummaryGroup,
    setAttributeEntity,
    useAlignments,
    useSizes,
} from 'metrix-common3';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import ProfileDriverCancellationReason from './CancellationReason';
import ProfileDriverClaim from './Claim';
import ProfileDriverConviction from './Conviction';
import ProfileDriverCriminalConviction from './CriminalConviction';
import ProfileDriverSuspension from './Suspension';

const ProfileDriver = (props) => {
    const sizes = useSizes();
    const alignments = useAlignments();

    const [mode, setMode] = useState('driver');
    const [current, setCurrent] = useState(null);

    const getDriverConvictions = () => {
        const driverConvictions = [];

        if (props.driver?.license?.convictions && props.driver.license.convictions.length > 0) {
            props.driver.license.convictions.forEach((conviction) => {
                const option = { code: conviction.reason?.value, value: conviction.guid };

                let convictionName = (
                    <FormattedMessage key={conviction.guid} id='Profile_Drivers_Driver.newConviction' />
                );

                if (conviction.reason?.value) {
                    convictionName = `${conviction.reason.value}`;
                }

                option.elements = [];

                option.elements.push({ code: 'Label', value: convictionName });

                driverConvictions.push(option);
            });
        }

        return driverConvictions;
    };

    const getDriverSuspensions = () => {
        const driverSuspensions = [];

        if (props.driver?.license?.suspensions && props.driver.license.suspensions.length > 0) {
            props.driver.license.suspensions.forEach((suspension) => {
                const option = { code: 'suspension', value: suspension.guid };

                let suspensionName = (
                    <FormattedMessage key={suspension.guid} id='Profile_Drivers_Driver.newSuspension' />
                );

                if (suspension.reinstatementDate) {
                    suspensionName = `${getFormattedDate(suspension.reinstatementDate, props.context.session.culture)}`;
                }

                option.elements = [];

                option.elements.push({ code: 'Label', value: suspensionName });

                driverSuspensions.push(option);
            });
        }

        return driverSuspensions;
    };

    const getDriverCriminalConvictions = () => {
        const driverCriminalConvictions = [];

        if (props.driver?.criminalConvictions && props.driver.criminalConvictions.length > 0) {
            props.driver.criminalConvictions.forEach((criminalConviction) => {
                const option = {
                    code: criminalConviction.reason?.value,
                    value: criminalConviction.guid,
                };

                let criminalConvictionName = (
                    <FormattedMessage key={criminalConviction.guid} id='Profile_Drivers_Driver.newCriminalConviction' />
                );

                if (criminalConviction.reason?.value) {
                    criminalConvictionName = `${criminalConviction.reason.value}`;
                }

                option.elements = [];

                option.elements.push({ code: 'Label', value: criminalConvictionName });

                driverCriminalConvictions.push(option);
            });
        }

        return driverCriminalConvictions;
    };

    const getDriverClaims = () => {
        const driverClaims = [];

        if (props.driver?.claims && props.driver.claims.length > 0) {
            props.driver.claims.forEach((claim) => {
                const option = { code: claim.reaason?.value, value: claim.guid };

                let claimName = <FormattedMessage key={claim.guid} id='Profile_Drivers_Driver.newClaim' />;

                if (claim.reason?.value) {
                    claimName = `${claim.reason.value}`;
                }

                option.elements = [];

                option.elements.push({ code: 'Label', value: claimName });

                driverClaims.push(option);
            });
        }

        return driverClaims;
    };

    const getDriverCancellationReasons = () => {
        const driverCancellationReasons = [];

        if (props.driver?.cancellationReasons && props.driver.cancellationReasons.length > 0) {
            props.driver.cancellationReasons.forEach((cancellationReason) => {
                const option = {
                    code: cancellationReason.reason?.value,
                    value: cancellationReason.guid,
                };

                let cancellationReasonName = (
                    <FormattedMessage key={cancellationReason.guid} id='Profile_Drivers_Driver.newCancellationReason' />
                );

                if (cancellationReason.reason?.value) {
                    cancellationReasonName = `${cancellationReason.reason.value}`;
                }

                option.elements = [];

                option.elements.push({ code: 'Label', value: cancellationReasonName });

                driverCancellationReasons.push(option);
            });
        }

        return driverCancellationReasons;
    };

    // Function to update child reference as per parent value
    const updateChildRef = (childRef, code) => {
        let ref = childRef;

        if (code && ref) {
            ref = ref.filter((x) => x.elements[0].value === code);
        }

        return ref;
    };

    const driverName = props.getDriverName() || `Driver ${props.driver.number}`;
    return (
        <React.Fragment>
            {mode === 'driver' && (
                <React.Fragment>
                    <BackButton clickEvent={props.backEvent} />
                    <Divider top={sizes.md} />
                    <Header size={sizes.md} textAlign={alignments.left} text={driverName} />
                    <NameForm
                        label={<FormattedMessage id='Profile_Drivers_Driver.name' />}
                        name={props.driver?.party?.name}
                        person={props.driver?.person}
                        saveEvent={props.doUpsertPolicy}
                        cancelEvent={props.doGetPolicy}
                        reference={props.reference}
                        changeEvent={(dotProp, value) =>
                            props.doReducePolicyElement({
                                code:
                                    dotProp === 'person.gender'
                                        ? `${props.dotProp}${dotProp}`
                                        : `${props.dotProp}party.name.${dotProp}`,
                                value,
                            })
                        }
                        allowEdit={props.allowEdit}
                    />
                    <PersonForm
                        label={<FormattedMessage id='Profile_Drivers_Driver.person' />}
                        person={props.driver?.person}
                        saveEvent={props.doUpsertPolicy}
                        cancelEvent={props.doGetPolicy}
                        reference={props.reference}
                        changeEvent={(dotProp, value) =>
                            props.doReducePolicyElement({
                                code: `${props.dotProp}person.${dotProp}`,
                                value,
                            })
                        }
                        allowEdit
                        culture={props.context.session.culture}
                    />
                    <Form
                        label={<FormattedMessage id='Profile_Drivers_Driver.driverDetails' />}
                        allowEdit={props.allowEdit}
                        saveEvent={() => props.doUpsertPolicy()}
                        cancelEvent={() => props.doGetPolicy()}
                    >
                        <FormInput
                            label={<FormattedMessage id='Profile_Drivers_Driver.number' />}
                            value={props.driver?.number}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({ code: `${props.dotProp}number`, value })
                            }
                            allowEdit
                        />
                        <FormRadio
                            label={<FormattedMessage id='Profile_Drivers_Driver.applicant' />}
                            value={props.driver && { code: convertFromBoolean(props.driver.applicant) }}
                            references={props.reference.references?.YesNo}
                            referencesEvent={() => props.reference.doGetReferences('YesNo')}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}applicant`,
                                    value: convertToBoolean(value.code),
                                })
                            }
                            allowEdit
                        />
                        <FormDropDown
                            label={<FormattedMessage id='Profile_Drivers_Driver.relationshipToApplicant' />}
                            value={props.driver?.relationshipToApplicant}
                            references={props.reference.references?.RelationToApplicant}
                            referencesEvent={() => props.reference.doGetReferences('RelationToApplicant')}
                            changeEvent={(value) =>
                                setAttributeEntity(
                                    `${props.dotProp}relationshipToApplicant`,
                                    value,
                                    props.doReducePolicyElement,
                                )
                            }
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Drivers_Driver.yearsContinuouslyInsured' />}
                            value={props.driver?.yearsContinuouslyInsured}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}yearsContinuouslyInsured`,
                                    value,
                                })
                            }
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Drivers_Driver.yearsWithPreviousInsurer' />}
                            value={props.driver?.yearsWithPreviousInsurer}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}yearsWithPreviousInsurer`,
                                    value,
                                })
                            }
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Drivers_Driver.yearsAtCurrentAddress' />}
                            value={props.driver?.yearsLivedAtCurrentAddress}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}yearsLivedAtCurrentAddress`,
                                    value,
                                })
                            }
                            allowEdit
                        />
                        <FormRadio
                            label={<FormattedMessage id='Profile_Drivers_Driver.driverTraining' />}
                            value={props.driver && { code: convertFromBoolean(props.driver.driverTraining) }}
                            references={props.reference.references?.YesNo}
                            referencesEvent={() => props.reference.doGetReferences('YesNo')}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}driverTraining`,
                                    value: convertToBoolean(value.code),
                                })
                            }
                            allowEdit
                        />
                        <FormRadio
                            label={<FormattedMessage id='Profile_Drivers_Driver.outOfCountryExperience' />}
                            value={
                                props.driver && {
                                    code: convertFromBoolean(props.driver.outOfCountryExperience),
                                }
                            }
                            references={props.reference.references?.YesNo}
                            referencesEvent={() => props.reference.doGetReferences('YesNo')}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}outOfCountryExperience`,
                                    value: convertToBoolean(value.code),
                                })
                            }
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Drivers_Driver.numberOfClaims' />}
                            value={props.driver?.numberOfLosses}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}numberOfLosses`,
                                    value,
                                })
                            }
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Drivers_Driver.timeframeOfClaims' />}
                            value={props.driver?.numberOfYearsForLosses}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}numberOfYearsForLosses`,
                                    value,
                                })
                            }
                            allowEdit
                        />
                    </Form>
                    <Form
                        label={<FormattedMessage id='Profile_Drivers_Driver.licenseDetails' />}
                        allowEdit={props.allowEdit}
                        saveEvent={() => props.doUpsertPolicy()}
                        cancelEvent={() => props.doGetPolicy()}
                    >
                        <FormInput
                            label={<FormattedMessage id='Profile_Drivers_Driver.ageFirstLicensed' />}
                            value={props.driver?.ageFirstLicensed}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}ageFirstLicensed`,
                                    value,
                                })
                            }
                            allowEdit
                        />
                        <FormDropDown
                            label={<FormattedMessage id='Profile_Drivers_Driver.issuingCountry' />}
                            value={
                                props.driver.license && {
                                    code: props.driver.license.countryCode,
                                    value: props.driver.license.country,
                                }
                            }
                            references={props.reference.references?.Country}
                            referencesEvent={() => props.reference.doGetReferences('Country')}
                            changeEvent={(value) => {
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}license.countryCode`,
                                    value: value.code,
                                });
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}license.country`,
                                    value: value.value,
                                });
                            }}
                            allowEdit
                        />
                        {props.driver.license &&
                        (props.driver.license.countryCode === '' ||
                            props.driver.license.countryCode === 'CAN' ||
                            props.driver.license.countryCode === 'USA') ? (
                            <FormDropDown
                                label={<FormattedMessage id='Profile_Drivers_Driver.issuingProvince' />}
                                value={
                                    props.driver.license && {
                                        code: props.driver.license.stateCode,
                                        value: props.driver.license.state,
                                    }
                                }
                                references={
                                    props.reference.references &&
                                    updateChildRef(
                                        props.reference.references.StateProvince,
                                        props.driver.license.countryCode,
                                    )
                                }
                                referencesEvent={() => props.reference.doGetReferences('StateProvince')}
                                changeEvent={(value) => {
                                    props.doReducePolicyElement({
                                        code: `${props.dotProp}license.stateCode`,
                                        value: value.code,
                                    });
                                    props.doReducePolicyElement({
                                        code: `${props.dotProp}license.state`,
                                        value: value.value,
                                    });
                                }}
                                allowEdit
                            />
                        ) : (
                            <FormInput
                                label={<FormattedMessage id='Profile_Drivers_Driver.state' />}
                                value={props.driver.license?.state}
                                changeEvent={(value) => {
                                    props.doReducePolicyElement({
                                        code: `${props.dotProp}license.stateCode`,
                                        value: '',
                                    });
                                    props.doReducePolicyElement({
                                        code: `${props.dotProp}license.state`,
                                        value: value,
                                    });
                                }}
                                allowEdit
                            />
                        )}
                        <FormInput
                            label={<FormattedMessage id='Profile_Drivers_Driver.licenseNumber' />}
                            value={props.driver?.license?.number}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}license.number`,
                                    value,
                                })
                            }
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Drivers_Driver.licenseClass' />}
                            value={props.driver?.license?.class}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}license.class`,
                                    value,
                                })
                            }
                            allowEdit
                        />
                        <FormDate
                            label={<FormattedMessage id='Profile_Drivers_Driver.issuedDate' />}
                            value={props.driver?.license?.issuedDate}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}license.issuedDate`,
                                    value,
                                })
                            }
                            culture={props.context.session.culture}
                            mode='past'
                            take={11}
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Drivers_Driver.numberOfConvictions' />}
                            value={props.driver?.license?.numberOfConvictions}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}license.numberOfConvictions`,
                                    value,
                                })
                            }
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Drivers_Driver.timeframeOfConvictions' />}
                            value={props.driver?.license?.numberOfYearsForConvictions}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}license.numberOfYearsForConvictions`,
                                    value,
                                })
                            }
                            allowEdit
                        />
                    </Form>
                    <Divider top={sizes.xl} />
                    <Header
                        size={sizes.lg}
                        textAlign={alignments.left}
                        text={<FormattedMessage id='Profile_Drivers_Driver.drivingConvictions' />}
                    />
                    <Container top={sizes.xl} bottom={sizes.xl}>
                        <SummaryGroup
                            allowAdd={props.allowEdit}
                            addEvent={() => {
                                props.doExecutePolicyAction({ code: 'CREATEDRIVERCONVICTION' });
                            }}
                            allowEdit
                            editEvent={(conviction) => {
                                props.doReduceParameter({ code: 'DriverConviction', value: conviction });
                                setCurrent(conviction);
                                setMode('conviction');
                            }}
                            allowDelete={props.allowEdit}
                            deleteEvent={(conviction) => {
                                props.doReduceParameter({ code: 'DriverConviction', value: conviction });
                                props.doExecutePolicyAction({ code: 'DELETEDRIVERCONVICTION' });
                                setCurrent(null);
                                setMode('driver');
                            }}
                            entities={getDriverConvictions()}
                            icon='drivingConviction'
                        />
                    </Container>
                    <Divider top={sizes.xl} />
                    <Header
                        size={sizes.lg}
                        textAlign={alignments.left}
                        text={<FormattedMessage id='Profile_Drivers_Driver.drivingSuspensions' />}
                    />
                    <Container top={sizes.xl} bottom={sizes.xl}>
                        <SummaryGroup
                            allowAdd={props.allowEdit}
                            addEvent={() => {
                                props.doReduceParameter({ code: 'Driver', value: props.driver.guid });
                                props.doExecutePolicyAction({ code: 'CREATEDRIVERSUSPENSION' });
                            }}
                            allowEdit
                            editEvent={(suspension) => {
                                props.doReduceParameter({ code: 'DriverSuspension', value: suspension });
                                setCurrent(suspension);
                                setMode('suspension');
                            }}
                            allowDelete={props.allowEdit}
                            deleteEvent={(suspension) => {
                                props.doReduceParameter({ code: 'DriverSuspension', value: suspension });
                                props.doExecutePolicyAction({ code: 'DELETEDRIVERSUSPENSION' });
                                setCurrent(null);
                                setMode('driver');
                            }}
                            entities={getDriverSuspensions()}
                            icon='drivingConviction'
                        />
                    </Container>
                    <Divider top={sizes.xl} />
                    <Header
                        size={sizes.lg}
                        textAlign={alignments.left}
                        text={<FormattedMessage id='Profile_Drivers_Driver.criminalConvictions' />}
                    />
                    <Container top={sizes.xl} bottom={sizes.xl}>
                        <SummaryGroup
                            allowAdd={props.allowEdit}
                            addEvent={() => {
                                props.doExecutePolicyAction({ code: 'CREATEDRIVERCRIMINALCONVICTION' });
                            }}
                            allowEdit
                            editEvent={(criminalConviction) => {
                                props.doReduceParameter({
                                    code: 'DriverCriminalConviction',
                                    value: criminalConviction,
                                });
                                setCurrent(criminalConviction);
                                setMode('criminalConviction');
                            }}
                            allowDelete={props.allowEdit}
                            deleteEvent={(criminalConviction) => {
                                props.doReduceParameter({
                                    code: 'DriverCriminalConviction',
                                    value: criminalConviction,
                                });
                                props.doExecutePolicyAction({ code: 'DELETEDRIVERCRIMINALCONVICTION' });
                                setCurrent(null);
                                setMode('driver');
                            }}
                            entities={getDriverCriminalConvictions()}
                            icon='criminalConviction'
                        />
                    </Container>
                    <Divider top={sizes.xl} />
                    <Header
                        size={sizes.lg}
                        textAlign={alignments.left}
                        text={<FormattedMessage id='Profile_Drivers_Driver.claims' />}
                    />
                    <Container top={sizes.xl} bottom={sizes.xl}>
                        <SummaryGroup
                            allowAdd={props.allowEdit}
                            addEvent={() => {
                                props.doExecutePolicyAction({ code: 'CREATEDRIVERCLAIM' });
                            }}
                            allowEdit
                            editEvent={(claim) => {
                                props.doReduceParameter({ code: 'DriverClaim', value: claim });
                                setCurrent(claim);
                                setMode('claim');
                            }}
                            allowDelete={props.allowEdit}
                            deleteEvent={(claim) => {
                                props.doReduceParameter({ code: 'DriverClaim', value: claim });
                                props.doExecutePolicyAction({ code: 'DELETEDRIVERCLAIM' });
                                setCurrent(null);
                                setMode('driver');
                            }}
                            entities={getDriverClaims()}
                            icon='claim'
                        />
                    </Container>
                    <Divider top={sizes.xl} />
                    <Header
                        size={sizes.lg}
                        textAlign={alignments.left}
                        text={<FormattedMessage id='Profile_Drivers_Driver.cancellations' />}
                    />
                    <Container top={sizes.xl} bottom={sizes.xl}>
                        <SummaryGroup
                            allowAdd={props.allowEdit}
                            addEvent={() => {
                                props.doExecutePolicyAction({ code: 'CREATEDRIVERCANCELLATIONREASON' });
                            }}
                            allowEdit
                            editEvent={(cancellationReason) => {
                                props.doReduceParameter({
                                    code: 'DriverCancellationReason',
                                    value: cancellationReason,
                                });
                                setCurrent(cancellationReason);
                                setMode('cancellationReason');
                            }}
                            allowDelete={props.allowEdit}
                            deleteEvent={(cancellationReason) => {
                                props.doReduceParameter({
                                    code: 'DriverCancellationReason',
                                    value: cancellationReason,
                                });
                                props.doExecutePolicyAction({ code: 'DELETEDRIVERCANCELLATIONREASON' });
                                setCurrent(null);
                                setMode('driver');
                            }}
                            entities={getDriverCancellationReasons()}
                            icon='cancellation'
                        />
                    </Container>
                </React.Fragment>
            )}
            {mode === 'conviction' && (
                <ProfileDriverConviction
                    conviction={props.driver.license.convictions.find((x) => x.guid === current)}
                    dotProp={`${props.dotProp}license.convictions.${props.driver.license.convictions.findIndex((x) => x.guid === current)}.`}
                    backEvent={() => {
                        setMode('driver');
                        setCurrent(null);
                    }}
                    doUpsertPolicy={props.doUpsertPolicy}
                    doGetPolicy={props.doGetPolicy}
                    doReducePolicyElement={props.doReducePolicyElement}
                    reference={props.reference}
                    context={props.context}
                    allowEdit={props.allowEdit}
                />
            )}
            {mode === 'suspension' && (
                <ProfileDriverSuspension
                    suspension={props.driver.license.suspensions.find((x) => x.guid === current)}
                    convictions={getDriverConvictions()}
                    dotProp={`${props.dotProp}license.suspensions.${props.driver.license.suspensions.findIndex((x) => x.guid === current)}.`}
                    backEvent={() => {
                        setMode('driver');
                        setCurrent(null);
                    }}
                    doUpsertPolicy={props.doUpsertPolicy}
                    doGetPolicy={props.doGetPolicy}
                    doReducePolicyElement={props.doReducePolicyElement}
                    reference={props.reference}
                    context={props.context}
                    allowEdit={props.allowEdit}
                />
            )}
            {mode === 'criminalConviction' && (
                <ProfileDriverCriminalConviction
                    criminalConviction={props.driver.criminalConvictions.find((x) => x.guid === current)}
                    dotProp={`${props.dotProp}criminalConvictions.${props.driver.criminalConvictions.findIndex((x) => x.guid === current)}.`}
                    backEvent={() => {
                        setMode('driver');
                        setCurrent(null);
                    }}
                    doUpsertPolicy={props.doUpsertPolicy}
                    doGetPolicy={props.doGetPolicy}
                    doReducePolicyElement={props.doReducePolicyElement}
                    reference={props.reference}
                    context={props.context}
                    allowEdit={props.allowEdit}
                />
            )}
            {mode === 'claim' && (
                <ProfileDriverClaim
                    claim={props.driver.claims.find((x) => x.guid === current)}
                    dotProp={`${props.dotProp}claims.${props.driver.claims.findIndex((x) => x.guid === current)}.`}
                    backEvent={() => {
                        setMode('driver');
                        setCurrent(null);
                    }}
                    doUpsertPolicy={props.doUpsertPolicy}
                    doGetPolicy={props.doGetPolicy}
                    doReducePolicyElement={props.doReducePolicyElement}
                    reference={props.reference}
                    context={props.context}
                    allowEdit={props.allowEdit}
                />
            )}
            {mode === 'cancellationReason' && (
                <ProfileDriverCancellationReason
                    cancellationReason={props.driver.cancellationReasons.find((x) => x.guid === current)}
                    dotProp={`${props.dotProp}cancellationReasons.${props.driver.cancellationReasons.findIndex((x) => x.guid === current)}.`}
                    backEvent={() => {
                        setMode('driver');
                        setCurrent(null);
                    }}
                    doUpsertPolicy={props.doUpsertPolicy}
                    doGetPolicy={props.doGetPolicy}
                    doReducePolicyElement={props.doReducePolicyElement}
                    reference={props.reference}
                    context={props.context}
                    allowEdit={props.allowEdit}
                />
            )}
        </React.Fragment>
    );
};

export default ProfileDriver;
